import { connect } from 'react-redux'
import BillersView from '../components/BillersView'
import {loadFavoritesBillers, doBillersSearch, changePobox, changeZip, changeBillerName, markSearchStarted} from '../modules/billers'
import {applicationLaunch} from "../../../store/application";
import _ from 'lodash';

const mapDispatchToProps = {
  loadFavoritesBillers: loadFavoritesBillers,
  doBillersSearch: doBillersSearch,
  changePobox: changePobox,
  changeZip: changeZip,
  changeBillerName: changeBillerName,
  markSearchStarted: markSearchStarted,
  next: (biller) => (dispatch, getStore) => {

    const locale = getStore().i18n.locale;

    dispatch(applicationLaunch(biller.app_guid, biller.product_id, locale, {
      biller_id: biller.biller_id,
      biller_name: biller.value || biller.biller_name,
      address_sequence: biller.address_sequence,
      biller_city_state_zip: biller.biller_city_state_zip,
      icon: biller.icon,
      name: biller.value || biller.biller_name
    }));
  }
};

const mapStateToProps = (state) => ({
  favorites: state.billers.favorites,
  searchResult: _.uniqBy(state.billers.searchResult || [], item => item.biller_id),
  billerPOBox: state.billers.billerPOBox,
  billerZip: state.billers.billerZip,
  billerName: state.billers.billerName,
  billerLoading: state.billers.billerLoading,
  searchStarted: state.billers.searchStarted
});

export default connect(mapStateToProps, mapDispatchToProps)(BillersView)


// WEBPACK FOOTER //
// ./src/components/Billers/containers/BillersContainer.js